import { ContentStream } from '@/components/shared/content-stream';
import { MarkdownRenderer } from '@/components/shared/markdown-renderer';

export interface AnimatedTextProps {
  text: string;
  isActive: boolean;
  onEnd?: () => void;
}

export const AnimatedText = ({ text, isActive, onEnd }: AnimatedTextProps) => {
  return isActive ? (
    <ContentStream
      content={text}
      splitBy="word"
      startDelayRange={[500, 1000]}
      tokenDelayRange={[20, 25]}
      onEnd={onEnd}
    >
      {({ markdownContent }) => <MarkdownRenderer markdown={markdownContent} />}
    </ContentStream>
  ) : (
    <MarkdownRenderer markdown={text} />
  );
};
